import React from 'react';
import { DNABox, Iffy } from '@alucio/lux-ui';
import { CrmIntegrationType } from '@alucio/aws-beacon-amplify/src/models';
import { useCRMStatus } from 'src/hooks/useCRMStatus';
import { CRMConnectionStatus, CRMSyncStatus } from 'src/state/machines/CRM/crmMachineTypes';
import VeevaLocation from './VeevaLocation';
import VeevaVaultLocation from './VeevaVaultLocation';

const CRMPrimaryAttendeeComponents = () => {
  const { connectionStatus, syncStatus, crmIntegrationType } = useCRMStatus();
  const isVeevaVaultCRM = crmIntegrationType === CrmIntegrationType.VEEVA_VAULT;
  const isVeevaSalesforceIntegration = crmIntegrationType === CrmIntegrationType.VEEVA;

  if (connectionStatus !== CRMConnectionStatus.CONNECTED || syncStatus !== CRMSyncStatus.SYNCED) {
    return null;
  }

  return (
    <DNABox fill>
      <Iffy is={isVeevaSalesforceIntegration}>
        <VeevaLocation />
      </Iffy>
      <Iffy is={isVeevaVaultCRM}>
        <VeevaVaultLocation />
      </Iffy>
    </DNABox>
  );
};

export default CRMPrimaryAttendeeComponents;
